import React from 'react';

import AuditHistoryModal from 'src/components/AuditHistoryModal';
import type { AuditHistoryEvent } from 'src/components/AuditHistoryModal';
import { OrgUser } from 'src/stores/OrgUserStore';
import { ANALYTICS_NAMES } from 'src/utils/analytics';

interface UserAuditHistoryModalProps {
    user: OrgUser;
    events: AuditHistoryEvent[];
    isLoading: boolean;
    isLoadingMore: boolean;
    hasMore: boolean;
    error?: string;
    onClose: Function;
    onLoadMore: Function;
}

function getUserName(user: OrgUser) {
    return [user.frstNm, user.lastNm].filter(Boolean).join(' ') || user.usrNm || 'User';
}

function UserAuditHistoryModal(props: UserAuditHistoryModalProps) {
    return (
        <AuditHistoryModal
            title={`${getUserName(props.user)} History`}
            emptyText="No audit history found for this user."
            events={props.events}
            isLoading={props.isLoading}
            isLoadingMore={props.isLoadingMore}
            hasMore={props.hasMore}
            error={props.error}
            analytics={{
                loadMore: ANALYTICS_NAMES.Users_AuditHistory_LoadMore,
                toggleChange: ANALYTICS_NAMES.Users_AuditHistory_ToggleChange,
            }}
            onClose={props.onClose}
            onLoadMore={props.onLoadMore}
        />
    );
}

export type { AuditHistoryEvent };
export default UserAuditHistoryModal;
